
export enum ListingFeature {
  abs= 'abs',
  airConditionedPassengers= 'airConditionedPassengers',
  alloyWheels= 'alloyWheels',
  armRest= 'armRest',
  asr= 'asr',
  breathalyzer= 'breathalyzer',
  cctv= 'cctv',
  cdPlayer= 'cdPlayer',
  certifiedEngineMaintenance= 'certifiedEngineMaintenance',
  certifiedGearboxMaintenance= 'certifiedGearboxMaintenance',
  coffeeMachine= 'coffeeMachine',
  coffeeTables= 'coffeeTables',
  curtains= 'curtains',
  doubleDecker= 'doubleDecker',
  doubleGlazedGlass= 'doubleGlazedGlass',
  driverBerth= 'driverBerth',
  dvdPlayer= 'dvdPlayer',
  enginePresent= 'enginePresent',
  extendableSeats= 'extendableSeats',
  externalCameras= 'externalCameras',
  firePreventionSystem= 'firePreventionSystem',
  footRest= 'footRest',
  gearboxPresent= 'gearboxPresent',
  hatBox= 'hatBox',
  heater= 'heater',
  indicatorSigns= 'indicatorSigns',
  internalCameras= 'internalCameras',
  kitchen= 'kitchen',
  microphone= 'microphone',
  openTop= 'openTop',
  passThroughLuggageCompartment= 'passThroughLuggageCompartment',
  preHeater= 'preHeater',
  radio= 'radio',
  recliningSeats= 'recliningSeats',
  refrigerator= 'refrigerator',
  retrocamera= 'retrocamera',
  safetyBelts= 'safetyBelts',
  seatPocket= 'seatPocket',
  seatsMonitor= 'seatsMonitor',
  seatsRadio= 'seatsRadio',
  seatsSocket220= 'seatsSocket220',
  seatsUsbPorts= 'seatsUsbPorts',
  socket220= 'socket220',
  spareWheel= 'spareWheel',
  toilet= 'toilet',

}